import { Input, Form } from "antd";
import PropTypes from "prop-types";

const AddVIN = ({ vin, setVin, t, isDuplicateVIN, setIsDuplicateVIN, setIsValidVIN }) => {
    // VIN validation regex pattern
    const VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;

    // Check if VIN is valid
    const isValidVIN = vin.length === 0 || VIN_PATTERN.test(vin);

    // Determine validation status
    const getValidationStatus = () => {
        if (isDuplicateVIN) return "error";
        if (vin.length > 0 && !isValidVIN) return "error";
        return "";
    };

    // Get help text for validation
    const getHelpText = () => {
        if (isDuplicateVIN) return t("duplicateVINError");
        if (vin.length > 0 && !isValidVIN) return t("invalidVINFormat");
        return "";
    };

    const handleVINChange = (e) => {
        const inputValue = e.target.value.toUpperCase(); // Convert to uppercase
        setVin(inputValue);
        setIsDuplicateVIN(false);
        setIsValidVIN(VIN_PATTERN.test(inputValue) || inputValue.length === 0);
    };

    return (
        <div>
            <p className="text-md font-medium mb-2">{t("vinNumber")}</p>
            <Form.Item
                validateStatus={getValidationStatus()}
                help={getHelpText()}
                rules={[
                    {
                        required: true,
                        whitespace: false,
                        message: t("vinRequired"),
                    },
                ]}>
                <Input
                    placeholder={t("enterVIN")}
                    value={vin}
                    onChange={handleVINChange}
                    maxLength={17}
                    minLength={17}
                />
            </Form.Item>
        </div>
    );
};

AddVIN.propTypes = {
    vin: PropTypes.string.isRequired,
    setVin: PropTypes.func.isRequired,
    isDuplicateVIN: PropTypes.bool.isRequired,
    setIsDuplicateVIN: PropTypes.func.isRequired,
    setIsValidVIN: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default AddVIN;
